import { createReducer } from '@reduxjs/toolkit';

import { storeSavedCampaign } from '../actions';

export default createReducer(
  null,
  /* eslint-disable no-param-reassign */
  {
    [storeSavedCampaign]: (state, { payload: { savedCampaign } }) =>
      savedCampaign,
  },
  /* eslint-enable no-param-reassign */
);
